import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=3e5fbd34&scoped=true&"
import script from "./Supplier.vue?vue&type=script&lang=js&"
export * from "./Supplier.vue?vue&type=script&lang=js&"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=3e5fbd34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5fbd34",
  null
  
)

component.options.__file = "Supplier.vue"
export default component.exports